// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cardListStyles } from "@guestsupply/Overrides/Widgets/SavedPayments/SavedPaymentsCardList";
import { color, ellipsis, getSystemColor, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

cardListStyles.centeringWrapper = {
    css: css`
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
    `,
};

cardListStyles.loadingSpinner = {
    css: css`
        margin: auto;
    `,
};

cardListStyles.sortBySelectWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 20px;
        ${xScreen("lte", "xs")} {
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
        }
    `,
};

cardListStyles.sortBySelect = {
    cssOverrides: {
        formField: css`
            width: 280px;
        `,
    },
};

cardListStyles.cardsCount = {
    size: 14,
    weight: "bold",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 280px;
            text-align: right;
            margin-bottom: 10px;
        }
    `,
};

cardListStyles.cardsContainer = {
    gap: 45,
};

cardListStyles.cardGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        ${xScreen("lte", "sm")} {
            display: flex;
            justify-content: center;
        }
    `,
};

cardListStyles.cardWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 150px;
        padding: 12px 16px;
        border-top: 4px solid ${color("secondary")};
        box-shadow: 0 4px 8px ${color("common.black", 0.1)};
        transition: box-shadow 0.3s ease;

        &:hover {
            box-shadow: 0 4px 8px ${color("common.black", 0.3)};

            & .actionsWrapper {
                opacity: 1;
            }
        }

        ${xScreen("lte", "md")} {
            overflow: visible;
            margin-bottom: 75px;
            &:hover .actionsWrapper {
                opacity: 1;
            }
        }

        ${xScreen("lte", "xs")} {
            max-width: 280px;
        }
    `,
};

cardListStyles.cardHeaderWrapper = {
    css: css`
        width: 100%;
        height: 50px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
    `,
};

cardListStyles.cardDescriptionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 318px;
    `,
};

cardListStyles.descriptionText = {
    size: 18,
    weight: "bold",
    css: css`
        margin: 0;
        ${ellipsis(1)}
    `,
};

cardListStyles.maskedCardNumberText = {
    size: 15,
    weight: "normal",
    css: css`
        margin: 0;
    `,
};

cardListStyles.cardTypeImage = {
    width: "48px",
    height: "35px",
    css: css`
        border-radius: 6px;
    `,
};

cardListStyles.cardBottomWrapper = {
    css: css`
        position: relative;
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;
    `,
};

cardListStyles.defaultCardMarker = {
    css: css`
        display: inline-block;
        position: absolute;
        left: -16px;
        bottom: -68px;
        border-top: 56px solid transparent;
        border-bottom: 56px solid transparent;
        border-left: 56px solid ${color("success")};
    `,
};

cardListStyles.defaultCardMarkerText = {
    size: 11,
    color: "white",
    css: css`
        position: absolute;
        top: -30px;
        left: -54px;
        white-space: nowrap;
        transform: rotate(45deg);
    `,
};

cardListStyles.nameOnCardAndExpDateWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: end;
    `,
};

cardListStyles.nameOnCardText = {
    size: 14,
    weight: "bold",
    css: css`
        text-align: right;
    `,
};

cardListStyles.expDateText = {
    size: 12,
    css: css`
        text-align: right;
    `,
};

cardListStyles.actionsWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 75px;
        opacity: 0;
        padding: 10px 16px;
        background-color: ${color("common.ui6")};
        transition: opacity 0.3s ease;
        ${xScreen("lte", "md")} {
            opacity: 1;
            bottom: -75px;
        }

        ${xScreen("lte", "xs")} {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    `,
};

cardListStyles.setDefaultCheckbox = {
    typographyProps: {
        size: 14,
        color: "white",
    },
};

cardListStyles.actionButtonsWrapper = {
    css: css`
        display: flex;
        gap: 20px;
    `,
};

cardListStyles.editButton = {
    variant: "secondary",
    color: "white",
    hoverStyle: {
        color: getSystemColor("common.ui8"),
        backgroundColor: getSystemColor("common.white"),
    },
    css: css`
        &&:focus {
            // using 2 & to override the hover style
            color: ${color("common.ui4")};
            border-color: ${color("common.ui4")};
        }
    `,
};

cardListStyles.deleteButton = {
    variant: "primary",
};
